import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const withToken = (key) => {
  const inst = axios.create({ baseURL: API });
  inst.interceptors.request.use((c) => {
    const t = localStorage.getItem(key);
    if (t) c.headers.Authorization = `Bearer ${t}`;
    return c;
  });
  return inst;
};

export const api = withToken("tpc_token");
export const viewerApi = withToken("tpc_viewer");

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message === "Network Error" ? "Can't reach the server. Check your connection." : "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}
